import React from 'react';
import { string, func, bool } from 'prop-types';
import classNames from 'classnames';
import { useConfiguration } from '../../context/configurationContext';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import { AspectRatioWrapper, NamedLink, ResponsiveImage } from '..';
import css from './ProfileCard.module.css';

export const ProfileCardComponent = props => {

  const {
    listing,
  } = props;

  const { publicData, authorData ,title  } = listing || {};
  const { displayName, userId ,profileImage } = authorData || {};
  const { professional_Skills,profileImage:image } = publicData || {};
  const maxVisible = 3; // Number of items to display
  const visibleSkills = professional_Skills && professional_Skills.slice(0, maxVisible);
  const remainingSkills = professional_Skills && professional_Skills.length - maxVisible;

  return (
    <NamedLink className={css.profileCardWrapper} name="ProfilePage" params={{ id: userId }}>
      <div className={css.profileIcon}>
        <ResponsiveImage
          rootClassName={css.thumbImage}
          url={profileImage?.secure_url?profileImage?.secure_url:image?.secure_url}
          variants={['listing-card']}
        />
      </div>

      <div className={css.profileInfo}>
        <div className={css.profileTitle}>{title}</div>
        <ul className={css.profileList}>
          {visibleSkills?.map((item, index) => (
            <li key={index} >
              {item.label}
            </li>
          ))}
          {remainingSkills ? <li ><span>+{remainingSkills}</span></li> : null}
        </ul>
        <div className={css.learnMoreButton}>
          <button> <FormattedMessage id="ProfileCard.learnMoreButtonText" /></button>
        </div>
      </div>
    </NamedLink>
  );
};

ProfileCardComponent.defaultProps = {
  className: null,
  rootClassName: null,
};

ProfileCardComponent.propTypes = {
  className: string,
  rootClassName: string,
  intl: intlShape.isRequired,
};

export default injectIntl(ProfileCardComponent);
